export const CLIENT_STAGING_URL = "booking-stg.cloudxier.dev";
export const API_STAGING_URL = "https://booking-api.cloudxier.dev/";
export const API_DEV_URL = 'http://localhost:3125/';

export const API_BASE_URL = window.location.host === CLIENT_STAGING_URL ? API_STAGING_URL : API_DEV_URL;
